import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { i18nClientReady } from './utils/pz/i18n.client.ts'
import { clientLogger } from './utils/pz/logger/clientLogger.ts'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

type HydrationDiagnostic = {
	message: string
	componentStack?: string
	digest?: string
}

declare global {
	interface Window {
		__PZ_HYDRATION_DIAGNOSTICS__?: HydrationDiagnostic[]
	}
}

const hydrationLog = clientLogger.scoped('Hydration')
const MAX_HYDRATION_DIAGNOSTICS = 10

function recordHydrationDiagnostic(
	error: unknown,
	errorInfo?: { componentStack?: string; digest?: string },
) {
	const message = error instanceof Error ? error.message : String(error)
	const diagnostic: HydrationDiagnostic = {
		message,
		componentStack: errorInfo?.componentStack,
		digest: errorInfo?.digest,
	}

	window.__PZ_HYDRATION_DIAGNOSTICS__ = [
		...(window.__PZ_HYDRATION_DIAGNOSTICS__ ?? []),
		diagnostic,
	].slice(-MAX_HYDRATION_DIAGNOSTICS)

	hydrationLog.error('recoverable hydration error', diagnostic)
}

i18nClientReady
	.catch(() => {
		// even if i18n init fails, attempt to hydrate to avoid a blank screen
	})
	.finally(() => {
		startTransition(() => {
			hydrateRoot(document, <HydratedRouter />, {
				onRecoverableError: recordHydrationDiagnostic,
			})
		})
	})
